import React, { VFC } from 'react';
import MainImage from '../../../../images/features/toyono/main.png';
import MainLogoImage from '../../../../images/features/toyono/main_logo.png';
import MainBgImage from '../../../../images/features/toyono/main_background.png';
import MainBgSpImage from '../../../../images/features/toyono/main_background_sp.png';
import IllustrationsLeftImage from '../../../../images/features/toyono/illust_left.png';
import IllustrationsRightImage from '../../../../images/features/toyono/illust_right.png';
import { Theme, useTheme } from '@material-ui/core/styles';
import styled from 'styled-components';
import Description from '~/src/feature/toyono/components/Description';
import Hidden from '@material-ui/core/Hidden';

const Container = styled.div<{ theme: Theme }>`
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 1200px;
    margin: auto;
    width: 100%;
  }
`;
const Main = styled.div<{ theme: Theme }>`
  background-image: url(${MainBgSpImage});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  padding: ${({ theme }) => theme.spacing(6, 4)}px;
  box-shadow: 0 32px 30px -30px rgb(53, 47, 47, 15%);
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: ${({ theme }) => theme.spacing(4)}px;
    background-image: url(${MainBgImage});
  }
`;
const H1 = styled.h1<{ theme: Theme }>`
  text-align: center;
  padding: 10% 10% 40%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 3% 0 8%;
  }
`;
const LogoImg = styled.img<{ theme: Theme }>`
  width: 70%;
  display: block;
  margin: 0 auto 5%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 300px;
    width: 100%;
    margin: 0 auto 1%;
`;
const Img = styled.img<{ theme: Theme }>`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 530px;
    width: 50%;
  },
`;
const LeftImg = styled.img<{ theme: Theme }>`
  position: absolute;
  width: 22%;
  max-width: 170px;
  left: 15%;
  bottom: 10%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    left: 5%;
    bottom: 15%;
  }
`;
const RightImg = styled.img<{ theme: Theme }>`
  position: absolute;
  width: 22%;
  max-width: 170px;
  right: 15%;
  bottom: 10%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    bottom: 15%;
    right: 5%;
  }
`;

interface Props {}

const Top: VFC<Props> = () => {
  const theme = useTheme();

  return (
    <Container theme={theme}>
      <Main theme={theme}>
        <LeftImg src={IllustrationsLeftImage} theme={theme} alt="" />
        <H1 theme={theme}>
          <LogoImg src={MainLogoImage} alt="おてつたび×豊能町" theme={theme} />
          <Img
            src={MainImage}
            alt="お手伝いしながらの旅で困りごとを解決＆町の魅力を再発見しよう！"
            theme={theme}
          />
        </H1>
        <Hidden smDown>
          <Description />
        </Hidden>
        <RightImg src={IllustrationsRightImage} theme={theme} alt="" />
      </Main>
      <Hidden mdUp>
        <Description />
      </Hidden>
    </Container>
  );
};

export default Top;
